import type { RoleConfig } from '../types.js';

export const disguiser: RoleConfig = {
  id: 'disguiser',
  faction: 'mafia',
  title: { ru: 'Двойник', uk: 'Двійник' },
  latin: 'DISGUISER',
  number: '48',
  accent: '#9a6cd6',
  sub: '#3a2470',
  ability: {
    ru: 'Ночью меняет местами действия двух игроков — их цели уезжают друг к другу.',
    uk: 'Уночі міняє місцями дії двох гравців — їхні цілі їдуть одна до одної.',
  },
  abilities: [
    {
      key: 'redirect',
      phase: 'night',
      cadence: 'every-night',
      shape: 'two-target',
      canSelfTarget: false,
    },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
